var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpgrade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3279_32295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.0185 10.7474C21.7122 8.5436 20.6898 6.50166 19.1089 4.93608C17.528 3.3705 15.4761 2.36815 13.2695 2.08342C11.0628 1.79869 8.82377 2.24738 6.89721 3.36038C4.97065 4.47337 3.46347 6.18893 2.60784 8.24278M1.98169 3.23359V8.24278H6.99088",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98169 13.252C2.28795 15.4557 3.31029 17.4977 4.89123 19.0632C6.47217 20.6288 8.524 21.6312 10.7307 21.9159C12.9373 22.2006 15.1764 21.7519 17.1029 20.6389C19.0295 19.526 20.5367 17.8104 21.3923 15.7565M22.0185 20.7657V15.7565H17.0093",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.031 12C10.031 12.5304 10.2417 13.0391 10.6168 13.4142C10.9919 13.7893 11.5006 14 12.031 14C12.5614 14 13.0701 13.7893 13.4452 13.4142C13.8203 13.0391 14.031 12.5304 14.031 12C14.031 11.4696 13.8203 10.9609 13.4452 10.5858C13.0701 10.2107 12.5614 10 12.031 10C11.5006 10 10.9919 10.2107 10.6168 10.5858C10.2417 10.9609 10.031 11.4696 10.031 12Z",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.031 8.5V10",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.031 14V15.5",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.0619 10.25L13.7629 11",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3 13L9 13.75",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 10.25L10.3 11",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7629 13L15.0629 13.75",
    stroke: "#111111",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3279_32295"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgrade);
export default __webpack_public_path__ + "static/media/Upgrade.882d2e038bb3f5a43e3bfe190a0162d3.svg";
export { ForwardRef as ReactComponent };